import { ThemeOptions } from '@mui/material';
import { zIndex } from 'types/common';

const FONT_FAMILIES = {
	barlow: 'Barlow, Arial, Helvetica, sans-serif',
	jetBrainsMono: '"JetBrains Mono", "Courier New", Courier, monospace'
};

const TYPOGRAPHY: ThemeOptions = {
	typography: {
		fontFamily: FONT_FAMILIES.barlow,
		h1: {
			fontWeight: 100,
			size: '96px',
			letterSpacing: '-1.5px',
			lineHeight: '112.03px',
			fontFamily: FONT_FAMILIES.jetBrainsMono
		},
		h2: {
			fontWeight: 200,
			size: '60px',
			lineHeight: '72px',
			letterSpacing: '-0.5px',
			fontFamily: FONT_FAMILIES.jetBrainsMono
		},
		h3: {
			fontWeight: 400,
			size: '48px',
			lineHeight: '58.02px',
			fontFamily: FONT_FAMILIES.jetBrainsMono
		},
		h4: {
			fontWeight: 400,
			size: '34px',
			lineHeight: '41.99px',
			letterSpacing: '0.25px',
			fontFamily: FONT_FAMILIES.jetBrainsMono
		},
		h5: {
			fontWeight: 400,
			size: '24px',
			lineHeight: '32.02px',
			fontFamily: FONT_FAMILIES.jetBrainsMono
		},
		h6: {
			fontWeight: 400,
			size: '20px',
			lineHeight: '32px',
			letterSpacing: '0.15px',
			fontFamily: FONT_FAMILIES.jetBrainsMono
		},
		subtitle1: {
			fontWeight: 400,
			size: '14px',
			lineHeight: '28px',
			letterSpacing: '0.15px',
			fontFamily: FONT_FAMILIES.barlow
		},
		subtitle2: {
			fontWeight: 500,
			size: '12px',
			lineHeight: '21.98px',
			letterSpacing: '0.1px',
			fontFamily: FONT_FAMILIES.barlow
		},
		body1: {
			fontWeight: 500,
			size: '16px',
			lineHeight: '24px',
			letterSpacing: '0.15px',
			fontFamily: FONT_FAMILIES.barlow
		},
		body2: {
			fontWeight: 500,
			size: '14px',
			lineHeight: '20.02px',
			letterSpacing: '0.17px',
			fontFamily: FONT_FAMILIES.barlow
		},
		button: {
			fontWeight: 600,
			size: '14px',
			textTransform: 'none',
			lineHeight: '24px',
			letterSpacing: '0.4px',
			fontFamily: FONT_FAMILIES.barlow
		},
		caption: {
			fontWeight: 500,
			size: '12px',
			lineHeight: '20.02px',
			letterSpacing: '0.17px',
			fontFamily: FONT_FAMILIES.barlow
		},
		overline: {
			fontWeight: 500,
			size: '10px',
			lineHeight: '20.02px',
			letterSpacing: '1.5px',
			fontFamily: FONT_FAMILIES.barlow
		}
	},
	zIndex
};

export default TYPOGRAPHY;
